/* ============
 * purchase Transformer
 * ============
 */

import Transformer from './transformer';

export default class purchaseTransformer extends Transformer {

  static send(previewParams) {
    return {
      email_to: previewParams.email_to,
      email_cc: previewParams.email_cc,
      message: previewParams.message,
      subject: previewParams.subject,
      // cc: previewParams.cc,
      test: previewParams.test,
      notes: previewParams.notes,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/purchaseMessage.js